module.exports = __webpack_public_path__ + "img/P1000911.96978891.jpg";